export default function getResource(label) {
    const resources = {
        showComparison: 'Show comparison',
        hideComparison: 'Hide comparison'
    };

    return resources[label];
}
